<template>

  <div class="c-app" :class="{ 'theme-is-dark': $store.state.theme === 'dark' }">
    <svg-icons/>
    <div
      class="sidebar-backdrop"
      :class="{ 'is-visible': sidebarMobileOpen }"
      @click="$store.commit('closeSidebarMobile')"
    ></div>
    <TheSidebar/>
    <CWrapper class="bg-light panel-wrapper panel-wrapper--no-header">
      <button
        type="button"
        class="panel-mobile-menu d-lg-none"
        title="منو"
        @click="$store.commit('toggleSidebarMobile')"
      >
        <CIcon name="iconMenu"/>
      </button>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>

            <Modals ref="modal2"/>
            <TranslateModals />
            <Loading ref="loading_component"/>

            <transition name="fade" mode="out-in">
              <keep-alive max="10">

                <router-view :key='$route.fullPath' v-slot="{ Component }" ref="root_view">
                  <component :is="Component"/>
                </router-view>
              </keep-alive>

            </transition>

          </CContainer>
        </main>
        <TheFooter/>
      </div>
    </CWrapper>
  </div>

</template>

<script>
import TheSidebar from './TheSidebar'
import TheFooter from './TheFooter'
import Modals from "../views/includes/Modals";
import Loading from "../views/includes/LoadingPage";
import TranslateModals from "@/views/includes/TranslateModals.vue";
import SvgIcons from "./svgIcons";

export const modal2 = null;
// Vue.use(Loading)
//
// // overwrite defaults
// Vue.use(Loading, {
//     dark: true, // default false
//     text: 'Ladataan', // default 'Loading'
//     loading: true, // default false
//     background: 'rgb(255,255,255)', // set custom background
//     classes: ['myclass'] // array, object or string
// })
export default {
  name: 'TheContainer',
  props: {},
  data() {
    return {
      modals2: '',

    }
  },
  computed: {
    sidebarMobileOpen() {
      return this.$store.state.sidebarShow === true
    }
  },
  components: {
    SvgIcons,
    Modals,
    Loading,
    TheSidebar,
    TheFooter,
    TranslateModals,
  },
  methods: {},
  watch: {
    '$route.path': function () {
      const pos = localStorage.getItem("scroll" + window.location.path)
      console.log("path changed",this.$route.path,pos)

      if (pos != null) {
        console.log("path changed",pos)
setTimeout(function (){
  window.scrollTo(0, parseInt(pos))

},1000)
      }
    }
  },
  mounted() {
    this.$store.commit('syncThemeForUser')
    this.$root.modal_component = this.$refs.modal2;
    this.$root.loading_component = this.$refs.loading_component;
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.12s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.panel-mobile-menu {
  position: fixed;
  top: 12px;
  left: 12px;
  z-index: 1020;
  width: 42px;
  height: 42px;
  border: 1px solid var(--panel-border, #e5e7eb);
  border-radius: 12px;
  background: var(--panel-surface, #fff);
  color: var(--panel-text, #111827);
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.08);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: pointer;
}

.panel-mobile-menu .c-icon {
  width: 20px;
  height: 20px;
}

html[dir="rtl"] .panel-mobile-menu {
  left: auto;
  right: 12px;
}
</style>
